import { call, take, put, fork, all } from 'redux-saga/effects';
import { StaticToast } from 'src/components/common';
import { fetchJson } from 'src/utils/fetch';
import { CouponType, CouponActionTypes } from './type';
// import * as Sentry from "@sentry/browser";

function* fetch_coupon_list() {
  while (true) {
    const action = yield take(CouponActionTypes.FETCH_COUPON_LIST);
    try {
      const { options, onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/user/coupon/list',
        type: 'POST',
        isloading: true,
        action,
        data: {
          ...options,
          option: {
            queryOrder: true,
          },
        },
      });
      if (res && res.code === '0') {
        const { result = [] } = res;
        // 问诊用的优惠券
        const inquiryCoupon: CouponType[] = [];
        // 购药用的优惠券
        const drugCoupon: CouponType[] = [];
        const extendedCoupons: CouponType[] = [];
        // 服务包的优惠券
        const servicePackageCoupons: CouponType[] = [];
        // 服务商品优惠券
        const serviceProductCoupons: CouponType[] = [];

        result.length &&
          result.forEach((element) => {
            const item: CouponType = {
              ...element.coupon,
              couponEffectiveTime: (element.couponEffectiveTime || '').replace(/-/g, '/'),
              couponExpiryTime: (element.couponExpiryTime || '').replace(/-/g, '/'),
              id: element.id,
              relatedOrderNo: element.relatedOrderNo,
              couponStatus: element.userCouponStatus,
              userCouponStatus: element.userCouponStatus,
              userCouponNo: element.userCouponNo,
              systemIdentification: element.systemIdentification || element.coupon?.systemIdentification || 1,
            };

            const { couponUseScope } = item;

            // 车险对接增加了couponUseScope === 'videoInquiry' couponUseScope === 'gjDrugs' 两种类型
            switch (couponUseScope) {
            case 'inquiry':
            case 'videoInquiry':
              serviceProductCoupons.push(item);
              break;
            case 'drugs':
            case 'express':
            case 'gjDrugs':
            case 'mallDrugs':
            case 'videoDrugs':
            case 'mallFastDrugs':
            case 'mallFastDrugsDoctor':
            case 'zaUmbrellaFastDrugsDoctor': // 商城同步优惠券
              serviceProductCoupons.push(item);
              break;
            case 'physicalExamExplain':  // 体检报告解读
            case 'physicalExam':  // 体检券 跟上面【体检报告解读】这个是不一样的 别去掉了
            case 'vaccine':
            case 'mentalRelease':
            case 'dentalExamination':
            case 'offlineProfessorRegister':
              serviceProductCoupons.push(item);
              break;
            case 'servicePackage':
              serviceProductCoupons.push(item);
              break;
            case 'serviceProduct':
              serviceProductCoupons.push(item);
              break;
            default:
              // 当 systemIdentification 为 2 时，也将 item 添加到 serviceProductCoupons
              if (item.systemIdentification === 2) {
                serviceProductCoupons.push(item);
              }
              break;
            }
          });

        typeof onSuccess === 'function' && onSuccess();
        yield put({
          type: CouponActionTypes.FETCH_COUPON_LIST_SUCCESS,
          inquiryCoupon,
          drugCoupon,
          extendedCoupons,
          servicePackageCoupons,
          serviceProductCoupons,
        });
      }
    } catch (error) {
      // Sentry.captureException(error);
      // StaticToast.error(error.message);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

export default function* root() {
  yield all([
    fork(fetch_coupon_list),
  ]);
}
